export const ADDRESS_SELECTSUCESS = 'ADDRESS_SELECTSUCESS';
export const ADDRESS_SELECTERROR = 'ADDRESS_SELECTERROR';

export const PHONE_VERIFYSUCESS = 'PHONE_VERIFYSUCESS';
export const PHONE_VERIFYERROR = 'PHONE_VERIFYERROR';

export const PAY_CONFIRMSUCCESS = 'PAY_CONFIRMSUCCESS';
export const PAY_CONFIRMERROR = "PAY_CONFIRMERROR";

/*OCR识别*/
export const OCR_IDENTIFYSTART = 'OCR_IDENTIFYSTART';
export const OCR_IDENTIFYSUCCESS = 'OCR_IDENTIFYSUCCESS';
export const OCR_IDENTIFYERROR = 'OCR_IDENTIFYERROR';

export const SEND_STATE = 'SEND_STATE';

export const SET_APPLICANT = 'SET_APPLICANT';
export const SET_INSURED = 'SET_INSURED';
